import { createApiRequest } from "../common";

export const deleteAccountApi = async (): Promise<void> => {
  const request = createApiRequest<void>('post', '/user/delete');
  return request({ confirmDelete: true });
};
